import * as React from 'react';
export function IconUspCancel(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      {...props}
    >
      <path fill="#D9F2FA" d="M90.906 18L110 37.01l-74.906 74.577L16 92.577z" />
      <path fill="#D9F2FA" d="M110 92.578l-19.093 19.01L16 37.01 35.094 18z" />
      <path
        d="M63.794 105.899c-22.33 0-40.494-18.085-40.494-40.316s18.164-40.315 40.493-40.315c22.33 0 40.494 18.084 40.494 40.315 0 22.231-18.165 40.316-40.494 40.316zm0-77.752c-20.739 0-37.601 16.789-37.601 37.436 0 20.648 16.862 37.436 37.6 37.436 20.739 0 37.601-16.788 37.601-37.436 0-20.647-16.862-37.436-37.6-37.436z"
        fill="#000"
        stroke="#000"
        strokeWidth={1.46}
      />
      <path
        d="M65.848 65.582l11.526-11.418a1.43 1.43 0 000-2.03 1.432 1.432 0 00-2.04 0L63.795 63.55l-11.54-11.417a1.445 1.445 0 00-2.04 0 1.43 1.43 0 000 2.03l11.527 11.418L50.215 77a1.43 1.43 0 000 2.03c.289.288.65.417 1.026.417.362 0 .738-.144 1.027-.417l11.54-11.418L75.35 79.03c.29.273.65.417 1.027.417.376 0 .738-.144 1.027-.417a1.43 1.43 0 000-2.03L65.848 65.582z"
        fill="#00A9E0"
        stroke="#00A9E0"
        strokeWidth={1.46}
      />
    </svg>
  );
}
